import { Component, OnInit } from '@angular/core';
import { trigger, transition, useAnimation, state, style, animate } from '@angular/animations';
import { bounceIn } from 'ng-animate';
import { ApiurlsService } from '../../../../services/api-urls/apiurls.service';
import { ApiDataServices } from '../../../../services/apiservices/api.services';

@Component({
  selector: 'hybse-admin-dashboardinfo',
  templateUrl: './dashboardinfo.component.html',
  styleUrls: ['./dashboardinfo.component.css'],
  animations: [
    trigger('bounceIn', [transition('* => *', useAnimation(bounceIn, {
      params: { timing: 3 }
    }))])]

})
export class DashboardinfoComponent implements OnInit {
  bounceIn: any;
  currentState = 'initial';
  listItem = [];
  list_order: number = 1;
  public activeInvestorCount: number;
  public activeIssuerCount: number;
  public inactiveInvestorCount: number;
  public inactiveIssuerCount: number;
  public investorCount: number;
  public issuerCount: number;
  public onlineInvestor: number;
  public onlineIssuer: number;
  public deletedInvestor: number;
  public deletedIssuer: number;
  public totalInv: number;
  public totalIss: number;



  constructor(private urls: ApiurlsService, private apiDataServices: ApiDataServices) { }

  changeState() {
    this.currentState = this.currentState === 'initial' ? 'final' : 'initial';
  }
  ngOnInit() {
    this.getOnlineUser();
  }
  public getOnlineUser(): void {
    let url: string = this.urls.getUserOverview
    this.apiDataServices.postApiData(url, {}).subscribe((response) => {
      if (response) {
        this.activeInvestorCount = response['data'].activeInvestorCount;
        this.activeIssuerCount = response['data'].activeIssuerCount;
        this.inactiveInvestorCount = response['data'].inactiveInvestorCount;
        this.inactiveIssuerCount = response['data'].inactiveIssuerCount;
        this.investorCount = response['data'].investorCount;
        this.issuerCount = response['data'].issuerCount;
        this.onlineInvestor = response['data'].onlineInvestor;
        this.onlineIssuer = response['data'].onlineIssuer;
        this.deletedInvestor = response['data'].deletedInvestor;
        this.deletedIssuer = response['data'].deletedIssuer;
        this.setCalculation();
      }
    });
  }

  public setCalculation(): void {
    this.totalInv = this.activeInvestorCount + this.inactiveInvestorCount + this.deletedInvestor;
    this.totalIss = this.activeIssuerCount + this.inactiveIssuerCount + this.deletedIssuer;
  }

}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/app/components/pages/dashboard/dashboardinfo/dashboardinfo.component.ts